let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kUoVo")]).then(() => parcelRequire('imc5x'));